import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishIngredientsQuantityPage } from "../dish-ingredients-quantity/dish-ingredients-quantity";
import { IngredientsServices } from "../../../../ingredients/services";
import { Globals } from '../../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { DeliberyNoteServices } from '../../../../delibery_note/services';
import { ProductsServices } from '../../../../products/services';

/**
 * Generated class for the DishIngredientsSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-ingredients-select',
  templateUrl: 'dish-ingredients-select.html',
})
export class DishIngredientsSelectPage {

  update_state: boolean = false;
  dish_uid: string;
  foodcost: any;
  foodcost_parts: number;
  foodcost_static: number;
  dish_name: string;
  dish: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public toastCtrl: ToastController,
    public globals: Globals,
    public translate: TranslateService,
    public deliberyNoteService: DeliberyNoteServices,
    public productsServices: ProductsServices) {

    this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update');
    this.foodcost = this.navParams.get('foodcost');
    this.foodcost_parts = this.navParams.get('foodcost_parts');
    this.foodcost_static = this.navParams.get('foodcost_static');
    this.dish_name = this.navParams.get('dish_name');
    this.dish = this.navParams.get('dish');
  }

  openDishIngQuantity() {
    if (this.ingredientsServices.foodcost_array_tmp.length > 0) {
      if (this.update_state) {
        this.globals.GAtrackView('Dish', 'Dish - Escandallo', this.globals.restaurant.email, 'Create/Update', 'Update foodcost select ings', 'Dish', this.dish_name);
      } else {
        this.globals.GAtrackView('Dish', 'Dish - Escandallo', this.globals.restaurant.email, 'Create/Update', 'Create foodcost select ings', 'Dish', this.dish_name);
      }
      this.navCtrl.push(DishIngredientsQuantityPage, {
        update: this.update_state,
        dish_uid: this.dish_uid,
        //foodcost: this.foodcost,
        foodcost_parts: this.foodcost_parts,
        foodcost_static: this.foodcost_static,
        dish_name: this.dish_name,
        dish: this.dish
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-ingrediente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async ionViewWillEnter() {
    //this.ingredientsServices.getPagesIngredients('all', 0);
    this.ingredientsServices.getPagesIngredientsProducts(0);
    this.ingredientsServices.page_active = 1;

    this.ingredientsServices.foodcost_array_tmp = []; //Reiniciamos array para no tener los antiguos valores.

    if (this.update_state) {
      if (this.foodcost != null) {
        if (this.foodcost.length > 0) {
          var ingredients = await this.ingredientsServices.getIngredients(this.globals.restaurant_uid);
          var products = await this.productsServices.getProducts(this.globals.restaurant_uid);
          ingredients = ingredients.concat(products);
          for (let entry of this.foodcost) {
            var index = ingredients.findIndex(x => x.UID == entry.uid);
            if (index >= 0) {
              var _array = Array();
              _array.push(entry.uid);
              _array.push(ingredients[index].name);

              if (ingredients[index].allergens == undefined) {
                ingredients[index].allergens = [];
                _array.push(ingredients[index].allergens);
              } else {
                _array.push(ingredients[index].allergens);
              }

              if (ingredients[index].sub_recipe) {
                _array.push(ingredients[index].price_static / parseFloat(ingredients[index].real_weight));
              } else {
                _array.push(ingredients[index].price_static);
              }
              _array.push(ingredients[index].measurement);
              _array.push(entry.quantity);
              _array.push(entry.waste);
              _array.push(ingredients[index].provider_static);
              _array.push(0); //Cantidad bruta
              _array.push(0); //Precio
              _array.push(ingredients[index].pvp === undefined ? 'ingredient' : 'product');
              this.ingredientsServices.foodcost_array_tmp.push(_array);
            }
          }
        }
      }
    } else {
      this.foodcost = Array();
      this.ingredientsServices.foodcost_array_tmp = Array();
    }
    this.ingredientsServices.foodcost_array_tmp = [...this.ingredientsServices.foodcost_array_tmp];
  }

  searchIngredientNode(value, type) {
    this.ingredientsServices.searchIngredientNode(value, type);
  }

  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-ingredients-select.ts